import React from 'react';
import {useTranslation} from 'react-i18next';
import {Row, Col} from 'reactstrap';
import {Select, DatePicker} from '@/Form';
import {buildSelectOptions} from '@/components/Form/formHelper';

const LapsedSurrender = () => {
  const {t: tr} = useTranslation('selection');

  return (
    <Row>
      <Col md={12}>
        <label>{tr('report:lapsed_surrender_date')}</label>
        <Row>
          <Col md={3}>
            <Select name='status'>
              {buildSelectOptions(tr('lapsed_surrender_options'))}
            </Select>
          </Col>
          <Col md={2}>
            <DatePicker name='dateFrom' />
          </Col>
          <Col md={2} className='pl-1'>
            <DatePicker name='dateTo' />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default LapsedSurrender;
